import { useMemo } from 'react';
import { PopupToggler } from '../blocks/PopupToggler';
import { ColumnsOutlineIcon } from '../icons/ColumnsOutlineIcon';
import { MultipleFilter } from '../filters/MultipleFilter';

import styles from '../filters/Filters.module.scss';

export function useVisibleColumnsToggler({ allColumns, visibleColumns, setVisibleColumns, disabled = false }) {
  const allVisibleColumns = useMemo(() => {
    const columns = Object.keys(allColumns);
    return columns.filter((column) => allColumns[column].canBeHidden);
  }, [allColumns]);

  const columnsOptions = useMemo(
    () => allVisibleColumns.map((column) => ({ value: column, label: allColumns[column].label })),
    [allVisibleColumns, allColumns],
  );

  const columnsDisplay = useMemo(() => {
    return Object.keys(allColumns).filter(
      (column) => !allColumns[column].canBeHidden || visibleColumns.includes(column),
    );
  }, [visibleColumns, allColumns]);

  const onChange = (selected) => {
    const sortedSelected = [...selected].sort((a, b) => allVisibleColumns.indexOf(a) - allVisibleColumns.indexOf(b));
    setVisibleColumns(sortedSelected);
  };

  const widget = (
    <PopupToggler icon={<ColumnsOutlineIcon />} info="Display Columns" hideCaret disabled={disabled}>
      <MultipleFilter
        key={allVisibleColumns}
        selected={visibleColumns}
        options={columnsOptions}
        onChange={onChange}
        className={styles.multipleFilterWrapper}
      />
    </PopupToggler>
  );

  return {
    widget,
    columnsDisplay,
  };
}
